(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-branding-slider"] && !Shopify.designMode) return;
  try {
    
  const swiperEl = document.querySelector('.hero-branding-slider__slides.swiper');
  if (swiperEl) {
    new Swiper(swiperEl, {
      loop: true,
      pagination: {
        el: swiperEl.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: swiperEl.querySelector('.swiper-button-next'),
        prevEl: swiperEl.querySelector('.swiper-button-prev'),
      },
      autoplay: {
        delay: 5000,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["series-jump-nav"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.series-jump__link');

    if (!link) return;

    const navigation = link.closest('.series-jump');
    const targetId = decodeURIComponent(link.hash.slice(1));
    let target = document.getElementById(targetId);

    // Shopify wraps JSON-template sections in a generated ID whose prefix
    // changes between themes/templates. Fall back to the stable JSON section
    // key (for example: collection-jumpfajas -> ...__jumpfajas).
    if (!target && targetId.startsWith('collection-')) {
      const sectionKey = targetId.slice('collection-'.length);
      target = document.querySelector(`[id$="__${sectionKey}"]`);
    }

    if (!navigation || !target) return;

    event.preventDefault();

    const offset = Number(navigation.dataset.scrollOffset) || 0;
    const targetTop = target.getBoundingClientRect().top + window.scrollY - offset;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    window.scrollTo({
      top: Math.max(0, targetTop),
      behavior: reduceMotion ? 'auto' : 'smooth'
    });

    window.history.replaceState(null, '', link.hash);
  });

  } catch(e) { console.error(e); }
})();
})();
